import { render } from "./FilterCollection.vue?vue&type=template&id=0090e220"
import script from "./FilterCollection.vue?vue&type=script&lang=js"
export * from "./FilterCollection.vue?vue&type=script&lang=js"

import "./FilterCollection.vue?vue&type=style&index=0&id=0090e220&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__